import { CodeSmall } from "@wix/wix-ui-icons-common";
import { createShortcut, Node_Type, quickActionsModalSections } from "./../ricos-types";
import { codeBlockConverter } from "./code-block-converter";
import { DEFAULTS } from "./defaults";
import { getAddButtons } from "./getAddButtons";
import { getTextButtons } from "./getTextButtons";
import { tiptapExtensions } from "./tiptap";
import { CODE_BLOCK_TYPE } from "./types";
const pluginCodeBlock = (config) => {
  const pluginConfig = { ...DEFAULTS.config, ...config };
  return {
    config: pluginConfig,
    type: CODE_BLOCK_TYPE,
    pmMarkConverters: [],
    pmNodeConverters: [codeBlockConverter],
    shortcuts: [
      createShortcut({
        name: Node_Type.CODE_BLOCK,
        description: "ShortcutsSheet_Formatting_CodeBlock",
        keys: { macOs: "Meta+Shift+C", windows: "Ctrl+Shift+C" },
        command({ publicCommands }) {
          publicCommands.setBlockType(CODE_BLOCK_TYPE);
        },
        group: "ShortcutsSheet_Section_Formatting",
        enabled: true
      })
    ],
    getAddButtons: (config2, services) => getAddButtons(config2, services),
    tiptapExtensions,
    textButtons: getTextButtons(),
    getQuickActions: () => [
      {
        id: "codeSnippet",
        title: "QuickActionsPlugin_ActionTitle_CodeSnippet",
        icon: CodeSmall,
        section: quickActionsModalSections.FormatLayout,
        tags: ["programming", "code block", "script", "developer", "code section", "syntax"],
        command: ({ publicCommands }) => publicCommands.setBlockType(CODE_BLOCK_TYPE)
      }
    ]
  };
};
export {
  pluginCodeBlock
};
//# sourceMappingURL=editor.js.map
